export default "__VITE_ASSET__fODlntCU__"